import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { take, concatMap, tap } from 'rxjs/operators';

import { Offer } from 'graphql/models/extended';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';

import { CloseOfferComponent } from '../close-offer/close-offer.component';

@Component({
  selector: 'app-close-offer-modal',
  templateUrl: './close-offer-modal.component.html',
  styleUrls: ['./close-offer-modal.component.scss']
})
export class CloseOfferModalComponent {
  @ViewChild(CloseOfferComponent) closeOfferComponent!: CloseOfferComponent;

  get form(): UntypedFormGroup {
    return this.closeOfferComponent.form;
  }

  constructor(
    protected fb: UntypedFormBuilder,
    public bsModalRef: BsModalRef,
    private offerService: OfferService,
    private storeService: StoreService
  ) { }

  onSubmit(): Observable<any> {
    this.closeOfferComponent.setPending(true);

    return this.storeService.getCurrentOffer()
      .pipe(
        concatMap((offer): Observable<Offer> => this.offerService.closeCurrentOffer(offer as Offer)),
        tap(() => {
          this.closeOfferComponent.setPending(false);
        }),
        take(1)
      );
  }
}
